import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-salesenquiry',
  templateUrl: './salesenquiry.component.html',
  styleUrls: ['./salesenquiry.component.css']
})
export class SalesenquiryComponent implements OnInit {

  constructor(private service:AppService,private router: Router) { }

  loader:boolean=false;
  errorMsg:any="";
  enquiryList:any=[];

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completesalesenquiry", "salesenquiry", "SalesEnquiry");

    fbq('track', "CompleteSalesEnquiry" , {
      content_type: "salesenquiry",
      content_title: this.router.url,
    });
  }

    this.loader=true;
    this.service.get('/salesEnquiryList').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.enquiryList=data[0].result;
        }else{
          this.errorMsg=data[0].msg;
        }
        this.loader=false;
      },error=>{
        this.loader=false;
        this.errorMsg=error.errorDesc;
      }
    )
  }

}
